import { createSelector } from 'reselect'

// PLOP_APPEND_PATTERN_ANCHOR

export const isInitialAuthCheckingSelector = createSelector(
  ({ cognito }) => cognito.initialAuthChecking,
  initialAuthChecking => initialAuthChecking
)

export const isAuthorizedSelector = createSelector(
  ({ cognito }) => cognito.isAuthorized,
  isAuthorized => isAuthorized
)

export const cognitoUserSelector = createSelector(
  ({ cognito }) => cognito.user,
  user => user
)

export const cognitoNextStepDataSelector = createSelector(
  ({ cognito }) => cognito.nextStep,
  nextStep => nextStep
)

export const loginErrorSelector = createSelector(
  ({ cognito }) => cognito.error,
  cognito => cognito
)

export const cognitoLoadingSelector = createSelector(
  ({ cognito }) => cognito.isLoading,
  isLoading => isLoading
)

export const isLoadingSelector = createSelector(
  ({ cognito }) => cognito.isLoading,
  isLoading => isLoading
)

export const createPasswordSelector = createSelector(
  ({ cognito }) => cognito.createPassword,
  createPassword => createPassword
)

export const createPasswordErrorSelector = createSelector(
  ({ cognito }) => cognito.createPasswordError,
  createPasswordError => createPasswordError
)

export const resetPasswordSelector = createSelector(
  ({ cognito }) => cognito.resetPassword,
  resetPassword => resetPassword
)

export const resetPasswordErrorSelector = createSelector(
  ({ cognito }) => cognito.resetPasswordError,
  resetPasswordError => resetPasswordError
)
